import Component from '../../shared/component';

const PAGE_PADDING_TOP = 15;

export default class FullHeightWindow extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$navbarElement = $('.navbar:visible');

    this.bindEvents();
    this.handleResize();
  }

  bindEvents() {
    this.handleResize = this.handleResize.bind(this);

    window.$window.on('resize.FullHeightWindow', this.handleResize);
  }

  unbindEvents() {
    window.$window.off('resize.FullHeightWindow', this.handleResize);
  }

  handleResize() {
    const viewportHeight =
      window.$window.height() -
      this.$navbarElement.outerHeight() -
      PAGE_PADDING_TOP;

    this.$element.outerHeight(viewportHeight);
  }
}
